import { headerLinks, sidebarLinks } from "./nav-links";
import { TEAM_ROLE_HIERARCHY, type TeamRole } from "./roles";

function checkTeamRoleAccess(
  teamRole: TeamRole,
  requiredRoles?: TeamRole[]
): boolean {
  if (!requiredRoles || requiredRoles.length === 0) return true;

  const teamRoleLevel = TEAM_ROLE_HIERARCHY[teamRole];
  const requiredLevel = Math.min(
    ...requiredRoles.map((role) => TEAM_ROLE_HIERARCHY[role])
  );

  return teamRoleLevel >= requiredLevel;
}

export function filterSidebarLinksByTeamRole(teamRole?: TeamRole) {
  if (!teamRole) {
    // User doesn't have a team, only show the home page link
    return sidebarLinks.filter((link) => link.to === "/");
  }
  return sidebarLinks.filter((link) =>
    checkTeamRoleAccess(teamRole, link.teamRoles)
  );
}

export function filterHeaderLinksByTeamRole(teamRole?: TeamRole) {
  if (!teamRole) {
    // User doesn't have a team, restrict access to all
    return [];
  }

  return headerLinks
    .filter((group) => checkTeamRoleAccess(teamRole, group.teamRoles))
    .map((group) => ({
      ...group,
      links: group.links.filter((link) =>
        checkTeamRoleAccess(teamRole, link.teamRoles)
      ),
    }))
    .filter((group) => group.links.length > 0);
}
